import React, { useState } from "react";
import RequestedDocumentsList from "./client-documents/RequestedDocumentsList";
import "../../styles/CaseDocuments.css";

const ClientDocuments = ({
  clientID,
  clientEmail,
  clientType,
  setShowClientIdSearch,
  showUploads,
  beneficiary,
  typeOptions,
  clientSubType,
  clientPhone,
  onOpenDocumentChange,
  chasingOnly,
  clientRecord,
}) => {
  const [selectedClientDocumentsType, setSelectedClientDocumentsType] =
    useState("All");
  const clientDocumentsType = ["All", "Recommended", "Required"];

  return (
    <div className="case-doc-content">
      <RequestedDocumentsList
        clientID={clientID}
        clientEmail={clientEmail}
        clientType={clientType}
        clientDocumentsType={clientDocumentsType}
        selectedClientDocumentsType={selectedClientDocumentsType}
        changeSelectedClientDocumentsType={(e) =>
          setSelectedClientDocumentsType(e.target.value)
        }
        setShowClientIdSearch={setShowClientIdSearch}
        showUploads={showUploads}
        beneficiary={beneficiary}
        typeOptions={typeOptions}
        clientSubType={clientSubType}
        clientPhone={clientPhone}
        onOpenDocumentChange={onOpenDocumentChange}
        chasingOnly={chasingOnly}
        clientRecord={clientRecord}
      />
    </div>
  );
};

export default ClientDocuments;
